import request from '../request'

export default {
  getTiposPersonal: function () {
    return request.get('personal_tipo')
  }
}
